function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import AdditionalLinks from './AdditionalLinks.react';
import BackButton from './BackButton.react';
import classnames from 'classnames';
import Headroom from 'react-headroom';
import injectStyles from '../jss';
import IPT from 'react-immutable-proptypes';
import Logo from './Logo.react';
import MainLinks from './MainLinks.react';
import MenuButton from './MenuButton.react';
import MobileLoginButton from './MobileLoginButton.react';
import NavigationLink from './NavigationLink.react';
import RPT from 'prop-types';
import SocialLinks from './SocialLinks.react';
import styles from './Navigation.jss';
export var Navigation = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Navigation, _React$PureComponent);
  function Navigation() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Navigation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Navigation)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isMenuOpen: false
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleMenu", function () {
      var isMenuOpen = _this.state.isMenuOpen;
      var toggleClass = isMenuOpen ? 'remove' : 'add';
      _this.setState({
        isMenuOpen: !isMenuOpen
      });
      _this.toggleClass(toggleClass);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideMenu", function () {
      _this.setState({
        isMenuOpen: false
      });
      _this.toggleClass('remove');
    });
    return _this;
  }
  _createClass(Navigation, [{
    key: "toggleClass",
    value: function toggleClass(_toggleClass) {
      window.document.documentElement.classList[_toggleClass]('menuShown');
      window.document.body.classList[_toggleClass]('menuShown');
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;
      var _this$props = this.props,
        additionalLinks = _this$props.additionalLinks,
        classes = _this$props.classes,
        classNameProp = _this$props.className,
        disabledLogo = _this$props.disabledLogo,
        filled = _this$props.filled,
        goBack = _this$props.goBack,
        headroomPinStart = _this$props.headroomPinStart,
        headroomWrapperStyle = _this$props.headroomWrapperStyle,
        links = _this$props.links,
        logo = _this$props.logo,
        logoClassName = _this$props.logoClassName,
        logoForTransparentBackground = _this$props.logoForTransparentBackground,
        logoUrl = _this$props.logoUrl,
        logoUrlExternal = _this$props.logoUrlExternal,
        menuButtonText = _this$props.menuButtonText,
        menuClassName = _this$props.menuClassName,
        mobileLinksNoMargin = _this$props.mobileLinksNoMargin,
        mobileLoginButton = _this$props.mobileLoginButton,
        mobileLogout = _this$props.mobileLogout,
        mobileTransparent = _this$props.mobileTransparent,
        progressBar = _this$props.progressBar,
        showBackButton = _this$props.showBackButton,
        backButtonClass = _this$props.backButtonClass,
        socialLinks = _this$props.socialLinks,
        staticHeader = _this$props.staticHeader,
        location = _this$props.location;
      var isMenuOpen = this.state.isMenuOpen;
      var className = classnames(classes.container, (_classnames = {}, _defineProperty(_classnames, classes.filled, filled), _defineProperty(_classnames, classes.mobileTransparent, mobileTransparent && !isMenuOpen), _classnames), classNameProp);
      var classNameHeadroom = classnames(classes.headroom, isMenuOpen && classes.headroom__fixed);
      var classNameMobileLinks = classnames(classes.mobileLinks, {
        visible: isMenuOpen
      }, mobileLinksNoMargin && classes.mobileLinksNoMargin);
      var mainLinks = React.createElement(MainLinks, {
        links: links,
        location: location,
        hideMenu: this.hideMenu
      });
      return React.createElement("div", null, React.createElement(Headroom, {
        disable: staticHeader,
        className: classNameHeadroom,
        wrapperStyle: headroomWrapperStyle,
        pinStart: headroomPinStart
      }, React.createElement("div", {
        className: className
      }, React.createElement("div", {
        className: classes.content
      }, React.createElement(MobileLoginButton, {
        hideMenu: this.hideMenu,
        mobileLoginButton: mobileLoginButton,
        isHidden: showBackButton
      }), showBackButton && React.createElement(BackButton, {
        goBack: goBack,
        className: backButtonClass
      }), React.createElement(Logo, {
        className: logoClassName,
        isMenuOpen: isMenuOpen,
        mobileTransparent: mobileTransparent,
        filled: filled,
        onClick: this.hideMenu,
        logo: logo,
        logoForTransparentBackground: logoForTransparentBackground,
        disabledLogo: disabledLogo,
        logoUrl: logoUrl,
        logoUrlExternal: logoUrlExternal
      }), React.createElement(MenuButton, {
        className: menuClassName,
        menuButtonText: menuButtonText,
        isMenuOpen: isMenuOpen,
        toggleMenu: this.toggleMenu
      }), React.createElement("div", {
        className: classes.links
      }, mainLinks))), !!progressBar && progressBar), React.createElement("div", {
        className: classNameMobileLinks
      }, mainLinks, mobileLogout && React.createElement("div", {
        className: classes.divided
      }, React.createElement(NavigationLink, _extends({}, mobileLogout, {
        hideMenu: this.hideMenu,
        pathname: location && location.pathname,
        hideOnDesktop: true
      }))), React.createElement(AdditionalLinks, {
        additionalLinks: additionalLinks,
        hideMenu: this.hideMenu
      }), React.createElement(SocialLinks, {
        socialLinks: socialLinks
      })));
    }
  }]);
  return Navigation;
}(React.PureComponent);
_defineProperty(Navigation, "styleRoot", 'Navigation');
_defineProperty(Navigation, "defaultProps", {
  filled: false,
  mobileTransparent: false,
  showBackButton: false
});
_defineProperty(Navigation, "contextTypes", {
  location: RPT.object,
  router: RPT.object,
  themeStyle: IPT.map
});
export default injectStyles(styles)(Navigation);